// extracted by mini-css-extract-plugin
var _1 = "InaccessibleMentionNotice-module__animatedBackground--tYKUx";
var _2 = "InaccessibleMentionNotice-module__button--ztieI";
var _3 = "InaccessibleMentionNotice-module__error--GKzwC";
var _4 = "InaccessibleMentionNotice-module__icon--bLZCV";
var _5 = "InaccessibleMentionNotice-module__title--LKh8e";
export { _1 as "animatedBackground", _2 as "button", _3 as "error", _4 as "icon", _5 as "title" }
